/* PackageListRenderer.js */

"use strict";
const _ = require("lodash");
const PackagePanel = require("../packagepanel/PackagePanelComponent");

class PackageListRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("package-list-gl");
        this._rootElem.component = this._model;

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._unregisterListeners();
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;

        let shutdownProms = this._shutdownPackageListComponents();

        return Promise.all(shutdownProms);
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on("PackagesReplaced", (this._onPackagesReplaced = this._onPackagesReplaced.bind(this)));
        this._model.on("PackagesReplaced", (this._onPackagesReplaced = this._onPackagesReplaced.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("PackagesReplaced", (this._onPackagesReplaced = this._onPackagesReplaced.bind(this)));
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._rebuildList();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }
    _onPackagesReplaced() {
        this.render();
    }
    _onLaunchEditor(editorState, editorName, opts) {
        this._model.launchEditor(editorState, editorName, opts);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _shutdownPackageListComponents() {
        let shutdownProms = [];

        //teardown repolist components
        if (!_.isEmpty(this._packageListComponents)) {
            this._packageListComponents.forEach((pkgComponent) => {
                shutdownProms.push(pkgComponent.shutdown());
                pkgComponent.removeListener("LaunchEditor", this._onLaunchEditor);
            });
        }
        this._packageListComponents = undefined;
        return shutdownProms;
    }
    _rebuildList() {
        let startUpProms = [];
        let shutdownProms = this._shutdownPackageListComponents();

        //Rebuild the _repoListComponents
        this._rootElem.innerHTML = "";
        //TODO add SORTing
        this._packageListComponents = [];
        let pkgs = this._model.getPackages();

        if (_.isEmpty(pkgs)) {
            this._rootElem.innerHTML = `
                <p class="no_available_packages">No Packages Found.</p>
            `;
        } else {
            pkgs.forEach((pkgSummary) => {
                let pkgComponent = new PackagePanel(pkgSummary);
                this._packageListComponents.push(pkgComponent);
                startUpProms.push(pkgComponent.renderer.render());
                this._rootElem.appendChild(pkgComponent.renderer.rootElement);

                pkgComponent.on("LaunchEditor", (this._onLaunchEditor = this._onLaunchEditor.bind(this)));
            });
        }
        return Promise.all(shutdownProms.concat(startUpProms));
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = PackageListRenderer;
